import { render, staticRenderFns } from "./RoomsMemberBySubrooms.vue?vue&type=template&id=f0b42ca2&scoped=true"
import script from "./RoomsMemberBySubrooms.vue?vue&type=script&lang=ts"
export * from "./RoomsMemberBySubrooms.vue?vue&type=script&lang=ts"
import style0 from "./RoomsMemberBySubrooms.vue?vue&type=style&index=0&id=f0b42ca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b42ca2",
  null
  
)

export default component.exports